import React from 'react';
import CustomTypography from '@src/new-components/Typography';
import DropdownCustom from '@src/new-components/Dropdown';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';

const NewUiSelectionType = ({
  options,
  currentValue,
  handleChange,
  icon,
  tooltipTitle,
}) => {
  const { t } = useTranslation();

  return (
    <DropdownCustom
      options={options.map((item) => ({
        label: item,
        value: item,
      }))}
      value={currentValue}
      onChange={handleChange}
      variant="format-audio"
      title={
        <CustomTypography variant="body-14-medium" color={COLOR.darkBlue}>
          {currentValue}
        </CustomTypography>
      }
      startIcon={icon}
      tooltipContent={t(tooltipTitle)}
    />
  );
};

export default NewUiSelectionType;
